//Please add the language resource
const dashboard = {
  msg:{
  }
};
export default dashboard



// WEBPACK FOOTER //
// ./src/page/report/dashboard/lang/dashboard.en.js